import { render, staticRenderFns } from "./stock_in_order.vue?vue&type=template&id=9235f306&scoped=true"
import script from "./stock_in_order.vue?vue&type=script&lang=js"
export * from "./stock_in_order.vue?vue&type=script&lang=js"
import style0 from "./stock_in_order.vue?vue&type=style&index=0&id=9235f306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9235f306",
  null
  
)

export default component.exports